import Markdown from '@/components/markdown/markdown';
import { Box, IconCheck, Text } from '@cmpsr/components';

// CheckBullet component for reusable check bullets
interface CheckBulletProps {
  children: string;
  color?: string;
}

const CheckBullet = ({ children, color = 'darkBlue' }: CheckBulletProps) => (
  <Box display="flex" height="spacer-10" paddingRight="spacer-4" alignItems="center" gap="spacer-2">
    <IconCheck color={color} size="s" />
    <Markdown
      components={{
        p: ({ children }) => (
          <Text
            color={color}
            fontSize={{ base: '12px', lg: '14px' }}
            fontWeight={400}
            lineHeight={{ base: '130%', lg: '140%' }}
          >
            {children}
          </Text>
        ),
      }}
    >
      {children}
    </Markdown>
  </Box>
);

export default CheckBullet;
